import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'nmo-simple-header',
    templateUrl: './simple-header.component.html',
    styleUrls: ['./simple-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SimpleHeaderComponent {}
